import styled from "styled-components";
import { Link } from "react-router-dom";

// Colores Corporativos para consistencia
const azul = "#147abe";
const grisClaro = "#E6E7E8";
const grisOscuro = "#505259";
const fondoCelda = "#f7f7f7";

// Contenedor principal
export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

// Área de contenido con margen superior
export const ContentWrap = styled.div`
  flex: 1;
  margin-top: 85px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// Estilo de la tabla
export const ContenedorTabla = styled.div`
  padding: 15px;
  border-radius: 10px;
  border: 1px solid ${grisOscuro};
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  background-color: white;
`;

// Título de la sección
export const Title = styled.div`
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: ${grisOscuro};
  align-self: flex-start;
`;

// Contenedor con ancho máximo
export const Div = styled.div`
  width: 80%;
  max-width: 1015px;
`;

// Estilo del enlace
export const StyledLink = styled(Link)`
  color: ${azul};
  text-decoration: none;
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`;

// Estilo de la celda de estado
export const EstadoCell = styled.td`
  background-color: ${({ estado }) => {
    switch (estado) {
      case "Pendiente":
        return "#fce282";
      case "Revisado":
        return "#dfd";
      case "Aprobado":
        return "#a3e1a3"; // Verde claro para aprobado
      case "Rechazado":
        return "#f8d7da"; // Rojo claro para rechazado
      default:
        return fondoCelda;
    }
  }};
  padding: 10px;
  text-align: center;
  font-weight: 600;
`;

// Agregar estilos para tabla y celdas con enfoque en mejorar la legibilidad
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  thead {
    background-color: ${azul};
    color: white;
  }

  th, td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid ${grisClaro};
  }

  tbody tr:nth-child(even) {
    background-color: ${fondoCelda};
  }

  tbody tr:hover {
    background-color: #f1f1f1;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    td, th {
      padding: 8px;
    }
  }
`;

